import * as yup from 'yup';
import { Typewriter } from '@web/atoms/Typewriter';

export const component = Typewriter;

export const schema = yup
  .object({
    words: yup.array(yup.string()),
    typography: yup.string(),
    fontColor: yup.string(),
    component: yup.string(),
  })
  .transform(value => ({
    words: value.words.split('/'),
    typography: value.typography || undefined,
    fontColor: value.font_color || undefined,
    component: value.component,
  }));
